export default {
  // ? ===================
  // ? =====  Layout  ====
  // ? ===================

  locationsPage: {
    '.content': {
      width: '100%'
    },
    '.locationTitle': {
      fontSize: ['2.5rem', '', '3rem', '4.25rem'],
      letterSpacing: '1px'
    },
    '.location': {
      flex: 1
    },
    '.logo': {
      backgroundColor: 'black',
      transform: 'unset',
      left: '0',
      top: '0',
      position: 'static',
      height: ['110px', '', '140px'],
      img: {
        objectFit: 'contain'
        // maxHeight: '300px!important'
      }
    },
    '.location2': {
      '.enterSiteButtonContainer': {
        position: 'relative',
        // top: '-200vh',
        // opacity: '0',
        '.enterSiteButton': {}
      },
      '.locationTitle': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }
  },

  navigation: {
    '.container': {
      backgroundColor: ['white', '', '', '#191919'],
      padding: ['0.5rem', '0.5rem', '1rem', '0rem'],
      zIndex: '1001'
    },

    '.smallNavMenu > div': {
      border: 'none',
      '.navItem': {
        color: 'white',
        a: {
          fontSize: ['1rem', '1rem', '1rem', '.75rem']
        }
      }
    },

    '.navItem': {
      color: 'light',
      margin: '0rem',
      padding: ['0.5rem', '0.5rem'],
      // width: '100%',
      width: 'fit-content',
      flexGrow: ['', '', '', '1'],
      margin: ['0rem 0rem 0.5rem', '0rem 0rem 1rem', '', '0rem'],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      a: {
        fontSize: ['1rem', '1.25rem', '1.25rem', '1rem']
      },
      ':hover': {
        color: 'inherit'
      }
    },

    '.hamburger': {
      order: '2',
      '> div': {
        backgroundColor: ['black', '', '', 'white']
      }
    },

    '.navMenuLogo': {
      position: 'static',
      width: ['100%', '', '100%'],
      padding: ['0.5rem', '', '2rem'],
      borderBottom: '1px solid',
      borderColor: 'secondary',
      margin: '0rem',
      img: {
        // filter: 'brightness(0) invert(1)',
        maxHeight: ['100px', '', '180px', '']
      }
    },
    '.navMenuOpen': {
      backgroundColor: 'primary',
      width: ['90%', '', '40%'],
      justifyContent: ['center', 'center', 'flex-start'],
      padding: ['2rem', '', '', '0rem'],
      '.seperatorLine': {
        width: '100%',
        maxWidth: 'unset',
        borderColor: 'secondary',
        margin: '1rem 0rem 0rem'
      },
      '.navItem': {
        padding: ['0.75rem'],
        a: {
          fontSize: ['1rem', '1.25rem', '1.5rem', '1.25rem']
        }
      }
    },
    '.navBlockOpen': {
      position: 'fixed',
      left: '0rem',
      top: '0rem',
      width: '100%',
      height: '100vh',
      backdropFilter: 'blur(2px)',
      backgroundColor: 'rgb(30 24 6 / 70%)'
    },
    '.phoneContainer': {
      width: 'fit-content',
      // filter: 'brightness(0) invert(1)',
      border: 'none',
      border: '2px solid',
      borderColor: 'primary',
      padding: '0.5rem',
      borderRadius: '1500px',
      svg: {
        path: {
          fill: ['white', '', '', 'primary']
        }
      }
    },
    '.addressContainer': {
      width: 'fit-content',
      border: 'none',
      // filter: 'brightness(0) invert(1)',
      border: '2px solid',
      borderColor: 'primary',
      padding: '0.5rem',
      borderRadius: '1500px',
      svg: {
        path: {
          fill: ['white', '', '', 'primary']
        }
      }
    },
    '.socialIconsContainer': {
      width: 'fit-content',
      filter: 'brightness(0) invert(1)'
    },

    '.socialContainer': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      a: {
        border: 'none',
        border: '2px solid',
        borderColor: 'primary',
        padding: '0.5rem',
        borderRadius: '1500px',
        margin: '0rem 0.25rem'
      },
      svg: {
        margin: '0rem',
        height: '20px',
        width: '20px'
      }
    },

    '.containerScrolled': {
      backgroundColor: ['white', '', '', '#191919'],
      borderBottom: '2px solid',
      borderColor: 'secondary',
      zIndex: '1001',
      '.hamburger > div': {
        // backgroundColor: '#c6a34d',
      }
    },

    '.logoScrolled': {
      // order: '1',
      left: ['50%', '', '', '1rem'],
      top: '45px',
      transform: ['translate(-50%, -50%)', '', '', 'unset'],
      img: {
        opacity: '1',
        maxHeight: ['70px', '80px', '80px', '80px']
      }
    },

    '.logo': {
      order: '1',
      left: ['50%', '', '', '1rem'],
      top: '10px',
      transform: ['translateX(-50%)', '', '', 'unset'],
      img: {
        opacity: '1',
        maxHeight: ['130px', '140px', '150px', '150px']
      }
    },

    '.locationSwitcher': {
      '.container': {
        backgroundColor: 'transparent'
      },
      '.locationSwitcherV1': {
        '.button': {
          fontSize: ['0.6rem', '0.7rem', '0.8rem', '0.8rem'],
          backgroundColor: 'black'
        }
      },
      padding: ['1rem .3rem', '', '', '0rem'],
      top: '0.5rem',
      left: '0rem',
      transform: 'unset'
    },

    '.popUp': {
      width: '100%',
      '.logo': {
        order: 'unset',
        transform: 'unset',
        maxWidth: '150px'
      },
      '.title': {
        mb: '1rem'
      },
      '.locations': {
        a: {
          variant: 'buttons.secondary',
          width: ['calc(50% - 1rem)', '', 'calc(50% - 2rem)'],
          margin: ['0.5rem', '', '1rem'],
          flexGrow: '1',
          fontSize: ['0.8rem', '', '0.9rem'],
          padding: ['0.75rem 1rem', '', '1rem 2rem']
        }
      }
    }
  },

  footer: {
    borderTop: '1px solid',
    borderColor: 'secondary',
    backgroundColor: '#6a4b24',
    color: 'white',
    padding: '2rem 1rem 8rem',
    paddingBottom: ['4rem', '', '', '100px'],
    '.socialContainer, .contactDetails-container': {
      svg: {
        path: {
          fill: 'primary'
        }
      }
    },
    '.logo': {
      // filter: 'brightness(0) invert(1)',
    },
    borderTop: '5px solid',
    borderColor: 'primary',
    '.sectionHeading': {
      color: 'secondary',
      fontWeight: '500',
      borderColor: 'secondary'
    },

    '.poweredBy .gonationLogo': {
      filter: 'brightness(0) invert(0.6)'
    },
    '.poweredByText': {
      margin: 'auto'
    },
    '.copyright': {
      backgroundColor: 'transparent',
      color: 'white',
      fontFamily: 'sans-serif'
    },
    '.multiButtonContainer': {
      justifyContent: ['center', '', '', 'flex-start'],
      borderTop: 'solid 2px',
      borderBottom: 'solid 2px',
      borderColor: 'primary'
    },
    '.socialContainer': {
      svg: {
        margin: '0.5rem',
        width: '40px',
        height: '40px',
        padding: '0.5rem',
        border: 'solid 1px',
        borderColor: 'primary',
        borderRadius: '1100px',
        path: {
          fill: 'primary'
        }
      }
    }
  },

  ctaWidget: {
    display: 'none!important',
    a: {
      backgroundColor: 'secondary'
    }
  },

  // ? ====================
  // ? ==== Reuseables ====
  // ? ====================

  title: {
    width: 'fit-content',
    // borderBottom: '2px solid',
    borderColor: 'secondary',
    display: 'flex',
    flexDirection: 'column',
    fontSize: ['1.75rem', '', '2.5rem'],
    textTransform: 'uppercase',
    color: 'text',
    fontWeight: 'bold',
    letterSpacing: '2px',
    whiteSpace: 'pre-wrap',
    marginBottom: '1.5rem',
    order: '2'
  },

  subtitle: {
    color: 'primary',
    fontWeight: 'normal',
    textTransform: 'initial',
    order: '1',
    fontFamily: 'body',
    fontSize: ['1rem', '1.5rem', '1.75rem', '2rem'],
    textTransform: 'uppercase'
  },

  text: {
    order: '3',
    fontSize: '1.25rem'
  },

  // forkGraphics: {
  //   display: 'flex',
  //   flexDirection: 'column',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   '::before': {
  //     content: "'⑂'",
  //     fontSize: '3rem',
  //     margin: '1rem 0rem',
  //   },
  //   '::after': {
  //     content: "'⑂'",
  //     fontSize: '3rem',
  //     transform: 'rotate(-180deg)',
  //     order: '7',
  //     margin: '1rem 0rem',
  //   },
  // },

  sideBySide1: {
    overflow: 'hidden',
    padding: '1rem',
    '.content': {
      // variant: 'customVariants.forkGraphics',
      order: ['', '', '2'],
      width: ['', '', '45%'],
      padding: ['2rem 1rem', '', '', '1.5rem 3.5rem', '2.5rem 4.5rem'],
      '.title': {
        variant: 'customVariants.title'
      },
      '.subtitle': {
        variant: 'customVariants.subtitle'
      },
      '.text': {
        variant: 'customVariants.text',
        textAlign: 'left',
        p: {
          textAlign: 'left'
        }
      },
      a: {
        order: '4'
      }
    },
    '.lazyload-wrapper': {
      order: '1',
      width: ['', '', '55%'],

      height: ['', '', '80vh'],
      '::before': {
        background: 'unset'
      },
      img: {
        // height: '100vh',
        border: ['solid 3px', 'solid 3px', 'solid 5px'],
        borderColor: ['secondary', 'secondary', 'secondary'],
        boxShadow: '2px 2px 10px black'
      }
    },
    '.ctaButton': {
      variant: 'buttons.secondary'
    }
  },

  sideBySide2: {
    padding: '1rem',
    overflow: 'hidden',
    flexDirection: ['', '', 'row'],
    paddingRight: ['', '', '1rem'],
    '.imageContainer': {
      order: '2',
      width: ['', '', '60%'],
      height: ['', '', '95vh'],
      position: 'relative',
      padding: ['1rem 0rem', '', '0rem'],
      '::before': {
        content: ['none', 'none', "''"],
        border: 'solid 3px',
        borderColor: 'white',
        position: 'absolute',
        height: '85%',
        width: '50vw',
        left: '10%',
        top: '15%'
      },
      img: {
        // height: '100vh',
      },
      '.image1': {
        position: ['', '', 'absolute'],
        top: '0%',
        left: '25%',
        width: ['', '', '75%'],
        height: ['', '', '75%'],
        border: ['solid 3px', 'solid 3px', 'solid 5px'],
        borderColor: ['secondary', 'secondary', 'secondary'],
        boxShadow: '2px 2px 10px black'
      },
      '.image3': {
        position: ['', '', 'absolute'],
        bottom: '10%',
        width: ['', '', '60%'],
        height: ['', '', '50%'],
        border: ['solid 3px', 'solid 3px', 'solid 5px'],
        borderColor: ['secondary', 'secondary', 'secondary'],
        boxShadow: '2px 2px 10px black'
      }
    },

    '.content': {
      // variant: 'customVariants.forkGraphics',
      order: '2',
      width: ['', '', '40%'],
      padding: ['2rem 1rem', '', '', '3rem 3.5rem', '4rem 4.5rem'],
      alignItems: 'flex-start',
      textAlign: 'left',
      backgroundColor: '#363636',
      margin: ['', '', 'auto 2rem auto 0rem'],
      color: 'white',
      height: 'fit-content',

      '.title': {
        variant: 'customVariants.title',
        color: 'inherit'
      },
      '.subtitle': {
        variant: 'customVariants.subtitle'
      },
      '.text': {
        variant: 'customVariants.text',
        p: {
          color: 'inherit'
        },
        color: 'inherit'
      },
      a: {
        order: '4'
      },
      '.ctaButton': {
        variant: 'buttons.secondary'
      }
    }
  },

  sideBySideParallax: {
    margin: ['1rem', '', '3rem', '4rem'],
    padding: '0rem',
    width: 'calc(100% -2rem)',
    height: ['', '', '75vh', '75vh'],
    backgroundPosition: ['center 100%', '', 'center center'],
    backgroundSize: ['150%', '', 'cover'],
    '.section': {
      // variant: 'customVariants.forkGraphics',
      width: ['', '', '40%'],
      maxWidth: 'unset',
      margin: ['auto', '', '0rem auto auto 3rem'],
      backgroundColor: 'white',
      padding: ['2rem 1rem', '', '3rem'],
      marginBottom: ['100%', '', '0rem'],
      backgroundColor: '#363636',
      color: 'white'
    },
    '.title': {
      variant: 'customVariants.title',
      color: 'inherit'
    },
    '.subtitle': {
      variant: 'customVariants.subtitle'
    },
    '.text': {
      variant: 'customVariants.text',
      textAlign: 'center',
      color: 'inherit',

      p: {
        color: 'inherit',
        textAlign: 'center'
      }
    },
    a: {
      order: '4'
    },
    '.ctaButton': {
      variant: 'buttons.secondary'
    }
  },

  // ? ====================
  // ? ====  Homepage  ====
  // ? ====================

  homepageHero: {
    '.section': {
      border: 'none',
      width: ['100%', '', '90%'],
      maxWidth: 'unset',
      margin: '0rem auto',
      height: 'auto',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center'
    },
    '.title': {
      variant: 'customVariants.title',
      border: 'none',
      padding: '0rem',
      fontSize: ['2rem', '2.5rem', '3.5rem', '5.5rem'],
      textShadow: '2px 2px 10px black',
      color: 'light'
    },
    '.subtitle': {
      variant: 'customVariants.subtitle'
    },
    '.text': {
      variant: 'customVariants.text',
      color: 'white'
    },
    '.ctaButton': {
      variant: 'buttons.primary'
    }
  },
  homepageHeroShout: {
    display: 'none'
  },

  homepageShout: {
    flexDirection: ['column', 'column', 'row'],
    '.imageContainer': {
      width: ['100%', '100%', '40%'],
      maxHeight: ['', '', '400px'],
      order: ['3', '', 'unset']
    },
    '.image': {
      padding: ['0rem', '', '1rem', '2rem'],
      objectFit: 'cover'
    },
    '.content': {
      backgroundColor: ['', '', 'transparent'],
      color: 'text',
      margin: ['', '', '2rem 1rem'],
      width: ['100%', '100%', '60%'],
      border: 'solid 2px',
      borderColor: 'secondary'
      // padding: ['', '', '0.5rem 5rem 0.5rem 2rem'],
    },
    '.text': {
      lineHeight: '1.5',
      color: ['primary', '', 'primary'],
      fontSize: ['1.25rem', '1.5rem', '1.75rem', '2rem'],
      letterSpacing: '1px',
      fontFamily: 'display',
      marginBottom: '2rem',
      fontWeight: 'bold'
    },
    '.title': {
      // width: ['3rem', '', '', '4rem'],
      textTransform: 'uppercase',
      color: ['text', '', 'text'],
      letterSpacing: '3px',
      marginBottom: '2rem'
    },
    '.date': {
      color: ['text', '', 'text']
      // display: 'none',
    },

    '.shoutCTA': {
      variant: 'buttons.secondary'
    }
  },

  homepageAbout: {
    variant: 'customVariants.sideBySideParallax'
  },

  homepageMenu: {
    variant: 'customVariants.sideBySide2'
  },

  homepageGallery: {
    variant: 'customVariants.sideBySide1'
  },

  homepageEvents: {
    variant: 'customVariants.sideBySide2'
  },

  homepageLocation: {
    variant: 'customVariants.sideBySideParallax'
  },

  homepageTestimonials: {
    padding: ['2rem 1rem', '', '4rem 3rem'],
    maxWidth: 'unset',
    '.innerMenuContainer ': {
      border: 'solid 1px',
      padding: ['1rem', '3rem']
    },
    '.menuSectionTitle': {
      variant: 'customVariants.title',
      border: 'none',
      textAlign: 'center',
      margin: '0 auto 1rem'
    },

    '.menuSectionDescription': {
      variant: 'customVariants.text',
      fontSize: '1rem'
    },

    '.menuItemNameContainer': {
      variant: 'customVariants.subtitle',
      order: '4',
      margin: '1rem auto 0rem',
      textAlign: 'center'
    },

    '.menuItemName': {
      fontSize: ['1rem', '1rem', '1rem', '1rem'],
      fontWeight: 'bold',
      fontSize: '1.5rem'
    },

    '.menuItemDescription': {
      variant: 'customVariants.text',
      color: 'primary',
      fontSize: '1.25rem',
      textAlign: 'center',
      lineHeight: '1.5',
      width: '100%',
      padding: ['0rem', '', '0rem 1rem'],
      margin: '0 auto 1rem'
    },

    '.slick-slider': {
      maxWidth: '767px',
      margin: '0 auto'
    }
  },
  // homepageChef: {
  //   padding: ['15vh 1rem', '', '20vh 1rem'],
  //   margin: ['0rem', '', '5rem 0rem 0rem'],
  //   '.section': {
  //     width: '75%',
  //     textAlign: 'left',
  //     alignItems: 'flex-start',
  //     margin: '0rem 0rem 0rem 10%',
  //   },
  //   '.title': {
  //     variant: 'customVariants.title',
  //     width: '100%',
  //     border: 'none',
  //     textAlign: 'left',
  //     color: 'light',
  //     textTransform: 'capitalize',
  //     fontSize: ['1.5rem', '2rem', '3rem', '4rem'],
  //   },
  //   '.subtitle': {
  //     variant: 'customVariants.subtitle',
  //     color: 'white',
  //     fontFamily: 'display',
  //     borderTop: '8px solid',
  //     borderColor: 'secondary',
  //     paddingTop: '1.5rem',
  //   },
  //   '.text': {
  //     variant: 'customVariants.text',
  //   },
  //   a: {
  //     order: '4',
  //   },
  //   '.ctaButton': {
  //     variant: 'buttons.secondary',
  //   },
  // },

  // ? ========================
  // ? =====  About page  =====
  // ? ========================

  aboutSection: {
    padding: ['3rem 1rem', '', '4rem 1rem', '4rem 1rem'],
    '.title': {
      fontSize: '2.5rem',
      color: 'secondary',
      fontWeight: '500',
      whiteSpace: 'pre-wrap',
      borderBottom: '2px solid',
      borderColor: 'secondary'
    },
    '.text': {
      fontSize: '1.2rem'
    }
  },

  // ? ========================
  // ? =====  Menu page  =====
  // ? ========================

  menu: {
    margin: '0rem 0rem',
    maxWidth: 'unset',
    padding: ['1rem', '', '1rem'],
    // backgroundImage:
    //   'url(https://media.gonation.com/w_800/sites/cast-iron-chef-kitchen-bar/pattern-bg.png)',
    backgroundColor: '#ede2cf',
    backgroundSize: 'auto',
    backgroundRepeat: 'repeat',
    border: ['solid 5px', 'solid 10px'],

    '.backToMenuBtn': {
      variant: 'buttons.secondary',
      margin: '0rem auto 2rem 0rem'
    },
    '.dropdownContainer': {
      display: 'none'
    },
    '.section-cell': {
      width: ['100%', '', 'calc(50% - 1rem)'],
      borderRadius: '0px',
      position: 'relative'
    },
    '.allInContainerWrapper ': {
      maxWidth: '1200px',
      margin: '0rem auto'
    },
    '.cellImageContainer': {
      overflow: 'hidden'
    },
    '.cellImage': {
      borderRadius: '0px',
      transition: 'all ease-in-out 0.5s',
      ':hover': {
        transform: 'scale(1.1) translate(-50%, -50%)',
        transformOrigin: 'center center'
      }
    },
    '.menuCell': {
      borderRadius: '0px',
      '.imageFill': {
        paddingBottom: '60%'
      }
    },

    '.cellName': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: 'light',
      margin: '0rem',
      fontSize: ['1.5rem', '', '1.75rem', '2.5rem']
    },

    '.tabsRow': {
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      maxWidth: '1200px',
      margin: '0rem auto',
      // flexDirection: 'row-reverse',
      '::before': {
        variant: 'customVariants.title',
        fontSize: ['1.5rem', '1.75rem', '2.5rem', '2.5rem', '3rem'],
        content: "'View The Menu'",
        margin: ['0rem 0rem 1.5rem', '', '0rem auto 0rem 0rem'],
        width: ['100%', '', '', 'fit-content'],
        letterSpacing: '0px',
        textTransform: 'capitalize',
        padding: '1rem 0rem',
        borderBottom: '3px solid',
        order: 'unset'
      },
      '.menuTab': {
        fontSize: '1.25rem',
        border: 'none',
        textTransform: 'capitalize',
        padding: '0.25rem',
        letterSpacing: '-1px',
        fontFamily: 'heading',
        height: 'fit-content',
        fontWeight: '500',
        backgroundColor: 'transparent',
        margin: '1rem 0.25rem 0rem'
      },
      '.menuTabActive': {
        color: 'text',
        borderBottom: '1px solid black'
      }
    },

    '.menuContainer': {
      paddingBottom: '0rem'
    },

    '.menuSectionTitle': {
      textAlign: 'left',
      margin: '1rem 0rem 1.5rem',
      fontSize: ['1.2rem', '1.3rem', '1.4rem', '1.5rem'],
      width: 'fit-content',
      borderBottom: 'solid 1px',
      borderColor: 'secondary',
      color: 'primary',
      padding: '1rem 0rem'
    },
    '.menuSectionDescription': {
      textAlign: 'left',
      // opacity: '0.75',
      fontSize: '0.9rem',
      color: 'secondary'
    },

    '.menuItemContainer, .menuItemContainerImgActive': {
      margin: '0rem 0rem 1rem',
      padding: ['0rem', '', '0rem 1.5rem 0rem 0rem']
    },

    '.menuItemInnerContainer': {
      margin: '0rem'
    },
    '.menuItemContentContainer': {
      margin: '0rem'
    },

    '.menuItemName': {
      marginBottom: '0rem',
      fontFamily: 'heading',
      fontSize: ['1.4rem', '1.4rem', '1.4rem', '1.5rem']
    },
    '.menuItemDescription': {
      color: 'secondary',
      fontSize: '1.3rem',
      opacity: '0.8'
    },
    '.menuItemPrice': {
      color: 'secondary',
      fontSize: '1.1rem'
    }
  },

  // ? ========================
  // ? ====  Gallery page  ====
  // ? ========================

  gallery: {
    '.albumsContainer': {
      // display: 'none',
    },
    '.albumTitle': {
      variant: 'buttons.secondary'
    }
  },

  // ? ========================
  // ? ====  Events page  ====
  // ? ========================

  events: {
    '.container': {
      padding: '0rem'
    },
    '.title': {
      backgroundColor: 'secondary',
      padding: '2rem 1rem',
      textTransform: 'uppercase',
      fontSize: ['2rem', '2.5rem', '3.5rem']
    },
    '.events-container': {
      maxWidth: 'unset'
    },

    '.no-events-container': {
      img: {
        filter: 'brightness(1) invert(1)'
      }
    },
    '.eventItemImage': {
      minHeight: 'unset',
      height: '100%',
      width: '100%',
      maxHeight: '350px'
    },
    '.eventDays, .eventDate': {
      color: 'black'
    },

    '.eventItemContent': {
      width: '100%'
    },

    '.eventItemTitle': {
      borderTop: '1px solid',
      marginBottom: '1.25rem',
      paddingTop: '1rem',
      fontSize: ['1.5rem', '', '2.5rem']
    },

    '.eventItemContainer': {
      flexDirection: 'column',
      width: ['100%', 'calc(50% - 4%)'],
      border: 'solid 5px',
      borderColor: 'secondary'
    },
    '.eventItemDescription': {
      color: 'secondary'
    }
  },

  // ? ========================
  // ? ====  Contact page  ====
  // ? ========================

  contactForm: {
    padding: '4rem 1rem',
    order: '4',
    backgroundColor: '#fff8f8',
    backgroundSize: 'auto',
    backgroundRepeat: 'repeat',
    '.title': {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '2.5rem',
      color: 'secondary',
      fontWeight: '500',
      whiteSpace: 'pre-wrap',
      borderBottom: '2px solid',
      borderColor: 'secondary',
      marginBottom: '2rem'
    },
    '.subtitle': {
      textTransform: 'initial',
      fontSize: '1rem',
      opacity: '0.8',
      marginBottom: '4rem'
    },
    form: {
      input: {
        border: 'none',
        borderRadius: '0px',
        borderBottom: '1px solid grey'
      },

      textarea: {
        border: 'none',
        borderRadius: '0px',
        borderBottom: '1px solid grey'
      },
      '.submitBtn': {
        variant: 'buttons.secondary',
        // borderRadius: '0px',
        textAlign: 'center',
        justifyContent: 'center'
      }
    }
  },

  locationMap: {
    order: '2',
    backgroundColor: 'primary',
    color: 'light',
    '.content_container': {
      border: 'solid 10px',
      borderColor: 'secondary'
    },
    h3: {
      textTransform: 'uppercase',
      fontSize: '2rem',
      color: 'secondary',
      borderBottom: '2px solid',
      borderColor: 'secondary'
    },
    '.dayofWeekText': {
      margin: '0 auto 0 0'
    }
  },

  // ? ========================
  // ? ====  Events Menu  ====
  // ? ========================

  eventsLeft: {
    variant: 'customVariants.sideBySide1'
  },
  eventsRight: {
    variant: 'customVariants.sideBySide2'
  },

  // ? ========================
  // ? ====  Catering  ====
  // ? ========================

  cateringSection: {
    '.title': {
      variant: 'customVariants.title',
      color: 'inherit'
    },
    '.subtitle': {
      variant: 'customVariants.subtitle'
    },
    '.text': {
      variant: 'customVariants.text',
      textAlign: 'center',
      color: 'inherit',

      p: {
        color: 'inherit',
        textAlign: 'center'
      }
    },
    '.linksContainer': {
      order: '4',
      mt: '2rem'
    },

    '.ctaButton': {
      variant: 'buttons.secondary'
    }
  },

  // ? ========================
  // ? ====  Press Menu  ====
  // ? ========================

  pressMenu: {
    padding: ['1rem', '1rem', '1rem', '1rem'],
    backgroundColor: 'background',
    '.boxesHeading': {
      display: 'none'
    },
    '.box': {
      backgroundColor: 'secondary',
      margin: ['1rem', '', '2rem'],
      width: ['100%', 'calc(50% - 0.5rem * 2)', 'calc(33.3% - 2rem * 2)']
    },
    '.imageContainer': {
      backgroundColor: 'black',
      img: {
        objectFit: 'contain'
      }
    },
    '.title': {
      color: 'light',
      borderBottom: '2px solid #cababa'
    },
    '.subtitle': {
      color: 'light'
    }
  },

  pressPage: {},

  // ? ========================
  // ? ====  Team Menu  ====
  // ? ========================

  teamMenu: {},

  teamPage: {},

  // ? ========================
  // ? ====  blog Menu  ====
  // ? ========================

  blogMenu: {},

  blogPage: {}
}
